<template>
  <v-row no-gutters class="v-cardgrid ml-1">
    <v-col sm="6" class="v-cardgrid-border">
      <v-row no-gutters>
        <v-col cols="8" sm="6" class="v-cardgrid-border v-cardgrid-top">
          <CantidadCajaIcon />
        </v-col>
        <v-col cols="4" sm="6" class="v-cardgrid-top">
          <Cantidad />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="8" sm="6" class="v-cardgrid-border v-cardgrid-top">
          <PzCajaIcon />
        </v-col>
        <v-col cols="4" sm="6" class="v-cardgrid-top">
          <PzCajaText />
        </v-col>
      </v-row>
    </v-col>
    <v-col sm="6">
      <v-row no-gutters>
        <v-col cols="8" sm="6" class="v-cardgrid-border v-cardgrid-top">
          <CajaPaletaIcon />
        </v-col>
        <v-col cols="4" sm="6" class="v-cardgrid-top">
          <CajaPaletaText />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="8" sm="6" class="v-cardgrid-border v-cardgrid-top">
          <CajaPaletaMtsIcon />
        </v-col>
        <v-col cols="4" sm="6" class="v-cardgrid-top">
          <ContMayor />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import PzCajaIcon from "./PzCajaIcon";
  import CajaPaletaMtsIcon from "./CajaPaletaMtsIcon";
  import CantidadCajaIcon from "./CantidadCajaIcon";
  import PzCajaText from "./PzCajaText";
  import Cantidad from "./Cantidad";
  import CajaPaletaIcon from "./CajaPaletaIcon";
  import CajaPaletaText from "./CajaPaletaText";
  import ContMayor from "./ContMayor";

  export default {
    components: {
      CantidadCajaIcon,
      PzCajaIcon,
      Cantidad,
      PzCajaText,
      CajaPaletaIcon,
      CajaPaletaText,
      ContMayor,
      CajaPaletaMtsIcon,
    },
};
</script>

<style scoped>
  .v-cardgrid {
    background-color: #ffffff !important;
    border: 1px solid black !important;
    transition: opacity 0.4s ease-in-out;
  }
  .v-cardgrid-border {
    border-right: 1px solid black !important;
  }
  .v-cardgrid-top {
    border-top: 1px solid black !important;
  }
  .v-cardgrid-botoom {
    background-color: #ffffff !important;
    border-bottom: 1px solid black !important;
    border-top: 1px solid black !important;
    border-right: 1px solid black !important;
    transition: opacity 0.4s ease-in-out;
  }
</style>
